import { lazyLoad } from "utils/loadable";

export const AddEmployerJobs = lazyLoad(
  () => import("./index"),
  (module) => module.EmployerAddEditJobs
);
